import Moment from 'moment';

export default {
    install(Vue) {
        Vue.filter('number', (n, places = 2, minimumPlaces = null) => {
            let options = {
                maximumFractionDigits: places
            };

            if (minimumPlaces !== null) {
                options.minimumFractionDigits = minimumPlaces;
            }

            /**
             * annual_income and monthly_income are sometimes explicitly set to NULL
             * and this generates a NaN error in the NumberFormat constructor
             */
            if (n === null || n === undefined) {
                n = '';
            }

            return new Intl.NumberFormat('en-US', options).format(String(n).replaceAll(",", ""));
        });

        Vue.filter('money', (n, places = 2) => {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: places,
                minimumFractionDigits: places
            }).format(String(n).replaceAll(",", ""));
        });

        Vue.filter('ucfirst', (str, toLowerFirst = false) => {
            if (!str) return
            
            if (toLowerFirst) {
                str = str.toLowerCase();
            }

            return (str + '').replace(/^(.)|\s+(.)/g, function ($1) {
                return $1.toUpperCase()
            });
        });

        Vue.filter('date', (date, format = 'YYYY-MM-DD') => {
            if (format === 'human') {
                return Moment.utc(date).from(Moment());
            }

            return Moment.utc(date).format(format);
        });

        Vue.filter('phone', (phoneNumber) => {
            let cleaned = ('' + phoneNumber).replace(/\D/g, '');

            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }

            return phoneNumber;
        });
    }
}
